import type { DetailedChangeset } from 'ember-changeset/types';
import isEmpty from 'lodash/isEmpty';

/**
 * Gets the latest value of a relationship from a changeset, falling back to the original data if not changed.
 * @param changeset the changeset
 * @param relationshipKey the relationship key
 * @returns the latest value of the relationship
 */
export function getChangesetLatestRelationship<M, K extends keyof M>(
  changeset: DetailedChangeset<M>,
  relationshipKey: K,
): M[K] {
  const changes = <M[K] | null>changeset.change[relationshipKey as string];
  return changes && !isEmpty(changes) ? changes : changeset.data?.[relationshipKey];
}
